// The eye on a password field: show what is being typed, then hide it again.
//
// NOT IN packs/, for the reason mock_composer.js records; imported by
// packs/application.js beside theme_toggle.js, whose shape this is.
//
// The button is rendered by ApplicationHelper#password_field_with_toggle,
// inside the field's .input-group and right after the input. This module is
// the enhancement on top: without it the button does nothing and the field is
// a plain password field, which is the right way to fail.
//
// Three things about it are easy to undo by accident:
//
// - THE INPUT IS THE BUTTON'S SIBLING, NEVER AN ID. A view can render the
//   field under any name (user[password], user[current_password], …) and the
//   helper does not have to invent an id for the button to point at.
// - ONE LISTENER ON THE DOCUMENT, ALWAYS. Delegated and installed whether or
//   not a field is on the page at load, so a field rendered later still
//   works, and a page with three fields does not carry three bindings.
// - THE STATE IS `aria-pressed`. The stylesheet draws the pressed eye from the
//   attribute and the label follows it, so a screen reader hears what a
//   sighted student sees.

const SELECTOR = "[data-password-toggle]";

function inputFor(button) {
  const group = button.closest(".input-group");
  return group ? group.querySelector("input") : null;
}

function toggle(button) {
  const input = inputFor(button);
  if (!input) return;

  const reveal = input.type === "password";
  input.type = reveal ? "text" : "password";

  button.setAttribute("aria-pressed", String(reveal));
  button.setAttribute("aria-label", reveal ? "Hide password" : "Show password");

  const icon = button.querySelector("i");
  if (icon) {
    icon.classList.toggle("fa-eye", !reveal);
    icon.classList.toggle("fa-eye-slash", reveal);
  }

  // Back to the field, so the student carries on typing where they were.
  input.focus();
}

function setup() {
  document.addEventListener("click", (event) => {
    const button = event.target.closest(SELECTOR);
    if (!button) return;
    event.preventDefault();
    toggle(button);
  });
}

// The same guard every module in this pack carries — see mock_request_wizard.js.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup);
} else {
  setup();
}
